import React from 'react';

function Canada(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124170)">
        <mask
          id="mask0_800_124170"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124170)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 0H27V24H9V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9735 7L18 19H17.3256L17.7394 16.0303C14.713 16.5144 13.3249 16.6343 13.5751 16.3902C13.8253 16.146 14.0224 15.8 14.1665 15.3521L10.125 12.9553C10.55 12.9506 10.9354 12.8568 11.2812 12.674C11.6269 12.4912 11.454 11.8578 10.7625 10.7737L12.803 11.0376L13.5751 10.2918L15.1146 11.7241H15.8066L15.1146 8.44343L16.355 9.05932L17.9735 7ZM17.9735 7L19.645 9.05932L20.8855 8.44343L20.1934 11.7241H20.8855L22.425 10.2918L23.197 11.0376L25.2375 10.7737C24.546 11.8578 24.3731 12.4912 24.7189 12.674C25.0646 12.8568 25.45 12.9506 25.875 12.9553L21.8335 15.3521C21.9776 15.8 22.1748 16.146 22.425 16.3902C22.6752 16.6343 21.2871 16.5144 18.2607 16.0303L18.6745 19H18L17.9735 7Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27 0H36V24H27V0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H9V24H0V0Z"
            fill="#E31D1C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124170">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Canada;
